<template>
  <el-dialog
    title="Update Housekeeping Status"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
  >
    <div v-if="room">
      <el-alert
        :title="`Room ${room.room_number} - ${room.room_type}`"
        type="info"
        :closable="false"
        show-icon
      >
        Current Status: <el-tag :type="getStatusType(room.housekeeping_status)">{{ room.housekeeping_status }}</el-tag>
      </el-alert>

      <el-form ref="form" :model="form" label-width="140px" class="mt-3">
        <el-form-item label="Housekeeping Status" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio-button label="clean">Clean</el-radio-button>
            <el-radio-button label="cleaning">Cleaning</el-radio-button>
            <el-radio-button label="dirty">Dirty</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="Assigned To" v-if="form.status === 'cleaning'">
          <el-input v-model="form.assigned_to" placeholder="Housekeeper name"></el-input>
        </el-form-item>

        <el-form-item label="Cleaning Time" v-if="form.status === 'clean'">
          <el-time-picker
            v-model="form.cleaning_time"
            format="HH:mm"
            value-format="HH:mm"
            placeholder="Select time"
          ></el-time-picker>
        </el-form-item>

        <el-form-item label="Notes">
          <el-input
            v-model="form.notes"
            type="textarea"
            :rows="3"
            placeholder="Additional notes (optional)"
          ></el-input>
        </el-form-item>

        <el-form-item label="Checklist" v-if="form.status === 'clean'">
          <el-checkbox-group v-model="form.checklist">
            <el-checkbox label="bed_made">Bed Made</el-checkbox>
            <el-checkbox label="bathroom_cleaned">Bathroom Cleaned</el-checkbox>
            <el-checkbox label="floor_cleaned">Floor Cleaned</el-checkbox>
            <el-checkbox label="trash_emptied">Trash Emptied</el-checkbox>
            <el-checkbox label="amenities_restocked">Amenities Restocked</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">
        Update Status
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import roomService from '@/services/room.service'

export default {
  name: 'HousekeepingDialog',
  props: {
    visible: Boolean,
    room: Object
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        status: '',
        assigned_to: '',
        cleaning_time: new Date().toTimeString().slice(0, 5),
        notes: '',
        checklist: []
      }
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (val && this.room) {
        this.form.status = this.room.housekeeping_status
      }
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    getStatusType (status) {
      const types = {
        clean: 'success',
        cleaning: 'warning',
        dirty: 'danger'
      }
      return types[status] || 'info'
    },

    handleClose () {
      this.form = {
        status: '',
        assigned_to: '',
        cleaning_time: new Date().toTimeString().slice(0, 5),
        notes: '',
        checklist: []
      }
      this.dialogVisible = false
    },

    async handleSubmit () {
      if (this.form.status === this.room.housekeeping_status) {
        this.$message.warning('Please select a different status')
        return
      }

      try {
        this.loading = true
        await roomService.updateHousekeepingStatus(this.room.id, this.form.status)
        this.$message.success('Housekeeping status updated successfully')
        this.$emit('updated')
        this.handleClose()
      } catch (error) {
        this.$message.error('Failed to update housekeeping status')
      } finally {
        this.loading = false
      }
    },

    async saveHousekeeping () {
      this.$refs.housekeepingForm.validate(async (valid) => {
        if (valid) {
          try {
            await this.withLoading(async () => {
              await this.$roomService.updateHousekeeping(this.roomId, this.housekeeping)
              this.showSuccess(this.$t('room.housekeeping.message.updated'))
              this.$emit('housekeeping-updated')
              this.$refs.housekeepingForm.resetFields()
              this.$emit('close', false)
            }, 'loading')
          } catch (error) {
            // Error is already handled by the global interceptor
            console.log('Component caught error in updateHousekeeping:', error)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.mt-3 {
  margin-top: 20px;
}
</style>
